exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#map[data-v-243e6a70]{margin:1rem auto;width:100%;height:50vh}#mapList[data-v-243e6a70]{margin-bottom:1rem}", ""]);

// exports
